module.exports = __webpack_public_path__ + "static/media/T9.ac4ca23b.jpg";